import FilterCondition from "../../../components/filter_aside/filter_condition.js";

export default class WatersFilterAside extends React.Component {
  constructor(props) {
    super(props);
    this.filter = this.filter.bind(this);
  }

  filter(key, value) {
    const { filters } = this.props;
    filters[key] = value;
    this.props.filter(filters);
  }

  render() {
    return(
      <form className='aside-filter filter'>
        <FilterCondition condition_name={'Водоемы'}
                         condition_param={'types'}
                         filter={this.filter}
                         enabled_ids={this.props.filters.types}
                         condition_items={this.props.data.type_list}
                         resetPageNum={this.props.resetPageNum} />
      </form>
    )
  }
}
